// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3N9OL","info":"PatientInfo_info__3C7SI"};